import React, { useState } from 'react';
import TilfoejMaerkeDagForm from '../components/forms/TilfoejMaerkeDagForm';
import TilfoejFoedselsDagForm from '../components/forms/TilfoejFoedselsDagForm';
import styles from './TilfoejDag.module.scss';

type TabType = 'maerkedag' | 'foedselsdag';

const TYPER = [
  {
    id: 'maerkedag' as TabType,
    emoji: '📅',
    titel: 'Mærkedag',
    undertitel: 'Jubilæum, konfirmation, historisk dag…',
    beskrivelse:
      'En særlig dag du vil markere på Askevej. Kan gentages hvert år eller kun forekomme én gang.',
    accentVar: 'var(--maerkedag)',
    accentBg: 'rgba(3, 105, 161, 0.07)',
    accentBorder: 'rgba(3, 105, 161, 0.3)',
  },
  {
    id: 'foedselsdag' as TabType,
    emoji: '🎂',
    titel: 'Fødselsdag',
    undertitel: 'En beboers fødselsdag',
    beskrivelse:
      'Tilføj en fødselsdato så vi alle kan huske at ønske tillykke og hejse flaget.',
    accentVar: 'var(--foedselsdag)',
    accentBg: 'rgba(217, 119, 6, 0.07)',
    accentBorder: 'rgba(217, 119, 6, 0.35)',
  },
];

const TilfoejDag: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType | null>(null);
  const activeType = TYPER.find((t) => t.id === activeTab);

  return (
    <div className={styles.page}>
      <div className={`${styles.content} container`}>
        <h1 className={styles.pageTitle}>Tilføj dag</h1>
        <p className={styles.pageSubtitle}>Hvad vil du tilføje?</p>

        {/* Type selector cards */}
        <div className={styles.typeGrid}>
          {TYPER.map((type) => {
            const isActive = activeTab === type.id;
            return (
              <button
                key={type.id}
                className={`${styles.typeCard} ${isActive ? styles.typeCardActive : ''}`}
                style={
                  isActive
                    ? {
                        background: type.accentBg,
                        borderColor: type.accentVar,
                        boxShadow: `0 0 0 3px ${type.accentBorder}`,
                      }
                    : {}
                }
                onClick={() => setActiveTab(type.id)}
                aria-pressed={isActive}
              >
                <span className={styles.typeEmoji}>{type.emoji}</span>
                <span className={styles.typeTitel}>{type.titel}</span>
                <span className={styles.typeUndertitel}>{type.undertitel}</span>
                {isActive && (
                  <span
                    className={styles.typeCheck}
                    style={{ color: type.accentVar }}
                    aria-hidden="true"
                  >
                    ✓
                  </span>
                )}
              </button>
            );
          })}
        </div>

        {/* Form — only shown once a type is chosen */}
        {activeType && (
          <div className={styles.formWrap}>
            {/* Form header banner */}
            <div
              className={styles.formHeader}
              style={{ background: activeType.accentBg, borderColor: activeType.accentBorder }}
            >
              <span className={styles.formHeaderEmoji}>{activeType.emoji}</span>
              <div>
                <div className={styles.formHeaderTitel} style={{ color: activeType.accentVar }}>
                  {activeType.titel}
                </div>
                <div className={styles.formHeaderBeskrivelse}>{activeType.beskrivelse}</div>
              </div>
            </div>

            <div className={styles.formCard}>
              {activeTab === 'maerkedag' ? (
                <TilfoejMaerkeDagForm />
              ) : (
                <TilfoejFoedselsDagForm />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TilfoejDag;
